// this.$store.state.planDesplazamiento
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
  orderBy,
} from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import { arreglos, colecciones } from "../constantes";

// PLAN DE VIAJE PARA DESPLAZAMIENTOS TERRESTRES
export const planDesplazamiento = {
  registro: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idEmpresa: "",
          idSupervisor: "",
          vehiculo: {
            id: "",
            idInspeccion: "",
            idSoat: "",
            idTecnicoMecanica: "",
            idCartaPropiedad: "",
            idPolizaContraActual: "",
            idPolizaTodoRiesgo: "",
          },
          conductor: {
            id: "",
            idLicencia: "",
            idCapacitacion: "",
            idAptitudFisica: "",
          },
          kilometrosEstimados: 0,
          tiempoEstimado: 0,
          fechaRealizacion: moment().format("YYYY-MM-DD"),
          estado: "Pendiente",
          secciones: [
            // PLANEACIÓN ANTES DEL VIAJE
            {
              id: 0,
              nombre: "PLANEACIÓN ANTES DEL VIAJE",
              campos: [
                {
                  id: 0,
                  tipo: `Opciones`,
                  nombre: `¿Para el desplazamiento se tramitó el control administrativo de movimiento con los centros de operaciones?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `N/A`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 1,
                  tipo: `Múltiple`,
                  nombre: `En caso de emergencia cuento con medios de comunicación para dar aviso oportunamente y con los siguientes elementos:`,
                  items:
                    arreglos.seguridadVial.planesDesplazamientos.mediosComunicacion.map(
                      (item) => {
                        return {
                          nombre: item,
                          observaciones: {
                            valor: false,
                            respuesta: null,
                          },
                        };
                      },
                    ),
                  respuesta: [],
                },
                {
                  id: 2,
                  tipo: `Opciones`,
                  nombre: `¿Estoy consciente que no debo hacer uso de teléfonos ni radios de dos vías, mientras conduzco?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 3,
                  tipo: `Opciones`,
                  nombre: `He planeado el viaje de acuerdo con la distancia y los limites de velocidad promedio establecidos para la ruta, teniendo el tiempo suficiente para llegar a mi destino sin afán y sin prisa.`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
              ],
            },
            // CONDICIONES DEL VEHICULO
            {
              id: 1,
              nombre: `CONDICIONES DEL VEHÍCULO`,
              campos: [
                {
                  id: 0,
                  tipo: `Personalizado`,
                  nombre: `Inspección pre-operacional del vehículo`,
                },
                {
                  id: 1,
                  tipo: `Opciones`,
                  nombre: `Todos los cinturones de seguridad del vehículo están en buenas condiciones y conozco que es mi responsabilidad que todos los pasajeros lo utilicen durante el viaje?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 2,
                  tipo: `Opciones`,
                  nombre: `Las cargas se encuentran debidamente amarradas y no exceden la capacidad del vehículo?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `N/A`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 3,
                  tipo: `Opciones`,
                  nombre: `Conozco que no debo llevar elementos sueltos en la cabina y cumplo con esta norma?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `N/A`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
              ],
            },
            // CONDICIONES DEL CONDUCTOR
            {
              id: 2,
              nombre: `CONDICIONES DEL CONDUCTOR`,
              campos: [
                {
                  id: 0,
                  tipo: `Personalizado`,
                  nombre: `Poseo licencia de conducción y está vigente?`,
                },
                {
                  id: 1,
                  tipo: `Personalizado`,
                  nombre: `Tengo válido el último curso de Manejo Defensivo?`,
                },
                {
                  id: 2,
                  tipo: `Opciones`,
                  nombre: `Mi estado de ánimo es bueno y la noche anterior descansé lo suficiente como para manejar el día de hoy. No me siento enfermo y físicamente estoy en buenas condiciones de realizar el recorrido?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 3,
                  tipo: `Opciones`,
                  nombre: `He recibido entrenamiento sobre Descanso y Fatiga, siendo conciente que debo controlar este factor de Riesgo?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 4,
                  tipo: `Opciones`,
                  nombre: `Si requiero gafas para conducir, hago uso de ellas?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `N/A`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 5,
                  tipo: `Opciones`,
                  nombre: `Manifiesto que estoy libre de cualquier condición física, emocional o psicológica, que afecte mi habilidad para conducir de manera segura. (Estrés, Uso de medicamentos que producen sueño, enfermo, calamidad doméstica, o situaciones críticas económicas que interfieran en mi concentración para conducir)?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 6,
                  tipo: `Opciones`,
                  nombre: `Conozco y estoy comprometido en el cumplimiento de la política de prevención de Alcohol y Drogas establecida para la organización, esto incluye la prohibición de consumo de cualquier bebida con alcohol (incluyendo Cerveza / guarapo) durante el desempeño de mis funciones o actividades?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 7,
                  tipo: `Personalizado`,
                  nombre: `Formulario de aptitud física`,
                },
              ],
            },
            // CONDICIONES DE LA RUTA Y EL CLIMA
            {
              id: 3,
              nombre: `CONDICIONES DE LA RUTA Y EL CLIMA`,
              campos: [
                {
                  id: 0,
                  tipo: `Múltiple`,
                  nombre: `El recorrido a realizar, cuenta con las siguientes condiciones de riesgo y conozco qué hacer en cada caso:`,
                  items:
                    arreglos.seguridadVial.planesDesplazamientos.condicionesRiesgo.map(
                      (item) => {
                        return {
                          nombre: item,
                          observaciones: {
                            valor: false,
                            respuesta: null,
                          },
                        };
                      },
                    ),
                  respuesta: [],
                },
                {
                  id: 1,
                  tipo: `Opciones`,
                  nombre: `Conozco los límites de velocidad establecidos según el área a transitar, tales como escuelas, poblaciones, vías destapadas, vías nacionales, vías en construcción, y dentro de las áreas de operación. (Pozos, Proyectos)`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
                {
                  id: 2,
                  tipo: `Opciones`,
                  nombre: `Si durante el viaje, transita por quebradas, en presencia de lluvias, sabe cómo actuar ante esta condición, para evitar incidentes al cruzar?`,
                  items: [
                    {
                      nombre: `Si`,
                      observaciones: {
                        valor: false,
                        respuesta: null,
                      },
                    },
                    {
                      nombre: `No`,
                      observaciones: {
                        valor: true,
                        respuesta: null,
                      },
                    },
                  ],
                  respuesta: null,
                },
              ],
            },
          ],
          registro: {
            tipo: "Online",
            idUsuario: "",
            estado: "Creado",
            filtro: moment().format("YYYY-MM-DD"),
            realizacion: {
              fecha: moment().format("YYYY-MM-DD"),
              hora: moment().format("hh:mm:ss A"),
            },
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            sincronizacion: serverTimestamp(),
            enCurso: {
              idUsuario: "",
              observaciones: "",
              coordenadas: {
                latitud: "",
                longitud: "",
                precision: "",
              },
              foto: {
                nombre: "",
                tipo: "",
                url: "",
              },
              registro: "",
              realizacion: {
                fecha: "",
                hora: "",
              },
            },
            finalizado: {
              idUsuario: "",
              observaciones: "",
              coordenadas: {
                latitud: "",
                longitud: "",
                precision: "",
              },
              foto: {
                nombre: "",
                tipo: "",
                url: "",
              },
              registro: "",
              realizacion: {
                fecha: "",
                hora: "",
              },
            },
          },
        };
      }
    },
    funciones: {
      async crear(planDesplazamiento, modoSinConexion, coleccion) {
        if (modoSinConexion) {
          planDesplazamiento.registro.tipo = "Offline";
          const obtenerRegistros = await localforage.getItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.planesDesplazamientos
                .registros,
          );
          const copia = obtenerRegistros
            ? JSON.parse(JSON.stringify(obtenerRegistros))
            : [];
          const registros = obtenerRegistros
            ? copia.concat([planDesplazamiento])
            : [planDesplazamiento];
          await localforage.setItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.planesDesplazamientos
                .registros,
            registros,
          );
        } else {
          await setDoc(
            doc(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.seguridadVial.planesDesplazamientos
                  .registros,
              planDesplazamiento.id,
            ),
            planDesplazamiento,
          );
        }
      },
      async actualizar(planDesplazamiento, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === planDesplazamiento.id)
            : -1;
          if (index !== -1) {
            registros[index] = planDesplazamiento;
            await localforage.setItem(
              colecciones.localforage.seguridadVial.planesDesplazamientos
                .registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .registros,
              planDesplazamiento.id,
            ),
            planDesplazamiento,
          );
        }
      },
      async eliminar(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === id)
            : -1;
          if (index !== -1) {
            registros.splice(index, 1);
            await localforage.setItem(
              colecciones.localforage.seguridadVial.planesDesplazamientos
                .registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .registros,
              id,
            ),
            {
              "registro.estado": "Eliminado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async obtener(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .registros,
          );
          return registros
            ? registros.find((item) => item.id === id)
            : null;
        } else {
          const q = query(
            collection(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .registros,
            ),
            where("id", "==", id),
            where("registro.estado", "in", ["Creado", "Editado"]),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs[0].data()
            : null;
        }
      },
      async generarID() {
        const refPlanDesplazamiento = doc(
          collection(
            db,
            colecciones.firebase.seguridadVial.planesDesplazamientos
              .registros,
          ),
        );
        return refPlanDesplazamiento.id;
      },
      descargarExcelSencillo(rows, nombre) {
        const XLSX = require("sheetjs-style");
        let wb = XLSX.utils.book_new();

        /* CONFIGURAR CABECERAS */
        const headers = [
          [
            "FECHA",
            "REGISTRO",
            "REALIZACIÓN",
            "REALIZADO POR",
            "CONDUCTOR",
            "PLACA",
            "CLASE",
            "ESTADO",
            "NOVEDADES",
            "CANT. DESCANSOS",
          ],
        ];

        /* AÑADIR CABECERAS A LA HOJA */
        const ws = XLSX.utils.aoa_to_sheet(headers);

        const stripHtml = (htmlString) => {
          return htmlString.replace(/<\/?[^>]+(>|$)/g, "");
        };

        const formatearNovedades = (novedades) => {
          if (
            novedades &&
            Array.isArray(novedades.items) &&
            novedades.items.length > 0
          ) {
            return novedades.items
              .map((item) => `• ${stripHtml(item)}`)
              .join("\r\n");
          }
          return "-";
        };

        /* CONFIGURACIÓN DE LOS DATOS */
        const jsonData = rows.map((item) => {
          const {
            fecha,
            registro,
            fechaRealizacion,
            realizadoPor,
            conductor,
            placa,
            clase,
            estado,
            novedades,
            cantidadDescansos,
          } = item;
          return {
            fecha,
            registro,
            fechaRealizacion,
            realizadoPor,
            conductor,
            placa,
            clase,
            estado,
            novedades: formatearNovedades(novedades),
            cantidadDescansos,
          };
        });

        /* DEFINIR CABECERAS PARA JSON */
        const jsonHeaders = [
          "fecha",
          "registro",
          "fechaRealizacion",
          "realizadoPor",
          "conductor",
          "placa",
          "clase",
          "estado",
          "novedades",
          "cantidadDescansos",
        ];

        /* AÑADIR DATOS Y CABECERAS */
        XLSX.utils.sheet_add_json(ws, jsonData, {
          origin: "A2",
          header: jsonHeaders,
          skipHeader: true,
        });

        /* DEFINIR ANCHO DE LAS COLUMNAS */
        ws["!cols"] = [
          { wch: 15 }, // FECHA
          { wch: 20 }, // REGISTRO
          { wch: 20 }, // REALIZACIÓN
          { wch: 40 }, // REALIZADO POR
          { wch: 40 }, // CONDUCTOR
          { wch: 25 }, // PLACA
          { wch: 25 }, // CLASE
          { wch: 25 }, // ESTADO
          { wch: 60 }, // NOVEDADES
          { wch: 35 }, // CANTIDAD DE DESCANSOS
        ];

        /* DEFINIR ALTO DE LAS COLUMNAS */
        ws["!rows"] = [
          {},
          ...jsonData.map((dataRow) => {
            const defaultHeight = 15;
            if (dataRow.novedades) {
              const lineCount = dataRow.novedades.split("\n").length;
              return { hpt: lineCount * 15 };
            }
            return { hpt: defaultHeight };
          }),
        ];

        /* ESTILOS DE CABERCERAS */
        const mergeHeaderStyle = {
          font: {
            bold: true,
            sz: 12,
            name: "Calibri",
            color: { rgb: "F3F3F3" },
          },
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
          fill: { fgColor: { rgb: "073d7a" } },
          border: {
            top: { style: "thin", color: { rgb: "FFFFFF" } },
            bottom: { style: "thin", color: { rgb: "FFFFFF" } },
            left: { style: "thin", color: { rgb: "FFFFFF" } },
            right: { style: "thin", color: { rgb: "FFFFFF" } },
          },
        };

        /* ESTILOS DE CELDAS */

        /* GENERAL */
        const dataCellStyle = {
          border: {
            top: { style: "thin", color: 1 },
            bottom: { style: "thin", color: 1 },
            left: { style: "thin", color: 1 },
            right: { style: "thin", color: 1 },
          },
          font: {
            name: "Arial",
            sz: 10,
            bold: false,
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },
        };

        /* ESTILOS PARA ESTADOS DEL PLAN DE DESPLAZAMIENTO */
        const stylesByState = {
          Pendiente: {
            fill: { fgColor: { rgb: "BFBFBF" } },
            font: { color: { rgb: "000000" }, bold: true },
          },
          "En Curso": {
            fill: { fgColor: { rgb: "073d7a" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
          "En Descanso": {
            fill: { fgColor: { rgb: "073d7a" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
          Finalizado: {
            fill: { fgColor: { rgb: "208454" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
        };

        /* ESTILOS BASE PARA SI Y NO */
        const successStyle = {
          fill: { fgColor: { rgb: "208454" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        };

        const dangerStyle = {
          fill: { fgColor: { rgb: "E6423C" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        };

        /* ASIGNAR ESTILOS A CABECERAS */
        for (let R = 0; R < headers.length; ++R) {
          for (let C = 0; C < headers[R].length; ++C) {
            const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
            if (!ws[cell_ref]) ws[cell_ref] = { t: "s", v: "" };
            ws[cell_ref].s = mergeHeaderStyle;
          }
        }

        /* ASIGNAR ESTILOS A CELDAS */
        jsonData.forEach((rowData, rowIndex) => {
          const excelRowIndex = rowIndex + 1;
          jsonHeaders.forEach((header, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({
              r: excelRowIndex,
              c: colIndex,
            });
            let cellStyle = { ...dataCellStyle };
            let cellValue = rowData[header];
            if (header === "estado") {
              const stateStyle = stylesByState[cellValue];
              if (stateStyle) {
                cellStyle = { ...cellStyle, ...stateStyle };
              }
            }
            if (header === "novedades") {
              cellStyle.alignment = {
                ...cellStyle.alignment,
                horizontal: "left",
              };
            }
            if (header === "cantidadDescansos") {
              cellStyle =
                rowData[header] > 0
                  ? { ...cellStyle, ...successStyle }
                  : { ...cellStyle, ...dangerStyle };
            }
            if (ws[cellRef]) {
              ws[cellRef].s = cellStyle;
            }
          });
        });

        /* IMPRIMIR EXCEL */
        XLSX.utils.book_append_sheet(wb, ws, "Planes de Desplazamientos");

        /* GENERAR ARCHIVO */
        XLSX.writeFile(
          wb,
          `${nombre
            ? nombre + " (Formato Sencillo)"
            : "Planes de Desplazamientos (Formato Sencillo)"
          }.xlsx`,
        );
      },
    },
  },
  reporte: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idPlanDesplazamiento: "",
          estado: "",
          foto: {
            nombre: "",
            tipo: "",
            url: "",
          },
          coordenadas: {
            latitud: "",
            longitud: "",
            precision: "",
          },
          observaciones: "",
          registro: {
            tipo: "Online",
            idUsuario: "",
            estado: "Creado",
            filtro: moment().format("YYYY-MM-DD"),
            realizacion: {
              fecha: moment().format("YYYY-MM-DD"),
              hora: moment().format("hh:mm:ss A"),
            },
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            sincronizacion: serverTimestamp(),
          },
        };
      }
    },
    funciones: {
      async crear(reporte, modoSinConexion, coleccion) {
        if (modoSinConexion) {
          reporte.registro.tipo = "Offline";
          const obtenerRegistros = await localforage.getItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.planesDesplazamientos
                .reportes.registros,
          );
          const copia = obtenerRegistros
            ? JSON.parse(JSON.stringify(obtenerRegistros))
            : [];
          const registros = obtenerRegistros
            ? copia.concat([reporte])
            : [reporte];
          await localforage.setItem(
            coleccion
              ? coleccion
              : colecciones.localforage.seguridadVial.planesDesplazamientos
                .reportes.registros,
            registros,
          );
        } else {
          await setDoc(
            doc(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.seguridadVial.planesDesplazamientos
                  .reportes.registros,
              reporte.id,
            ),
            reporte,
          );
        }
      },
      async actualizar(reporte, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .reportes.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === reporte.id)
            : -1;
          if (index !== -1) {
            registros[index] = reporte;
            await localforage.setItem(
              colecciones.localforage.seguridadVial.planesDesplazamientos
                .reportes.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .reportes.registros,
              reporte.id,
            ),
            reporte,
          );
        }
      },
      async eliminar(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .reportes.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === id)
            : -1;
          if (index !== -1) {
            registros.splice(index, 1);
            await localforage.setItem(
              colecciones.localforage.seguridadVial.planesDesplazamientos
                .reportes.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .reportes.registros,
              id,
            ),
            {
              "registro.estado": "Eliminado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async obtener(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .reportes.registros,
          );
          return registros
            ? registros.find((item) => item.id === id)
            : null;
        } else {
          const q = query(
            collection(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .reportes.registros,
            ),
            where("id", "==", id),
            where("registro.estado", "in", ["Creado", "Editado"]),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs[0].data()
            : null;
        }
      },
      async generarID() {
        const refReporte = doc(
          collection(
            db,
            colecciones.firebase.seguridadVial.planesDesplazamientos
              .reportes.registros,
          ),
        );
        return refReporte.id;
      },
      async obtenerRegistrosPlan(idPlan, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.seguridadVial.planesDesplazamientos
              .reportes.registros,
          );
          const reportes = registros
            ? registros.filter(
              (item) => item.idPlanDesplazamiento == idPlan,
            )
            : [];
          return reportes ? reportes : [];
        } else {
          const q = query(
            collection(
              db,
              colecciones.firebase.seguridadVial.planesDesplazamientos
                .reportes.registros,
            ),
            where("idPlanDesplazamiento", "==", idPlan),
            where("registro.estado", "in", ["Creado", "Editado"]),
            orderBy("registro.creacion", "asc"),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs.map((doc) => doc.data())
            : [];
        }
      },
    },
  },
};
